module.exports = __webpack_public_path__ + "img/web.ba6dba16.jpg";